import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth,
  children,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-atomic-green text-black hover:bg-atomic-hover border border-transparent shadow-[0_0_15px_rgba(163,230,53,0.3)] hover:shadow-[0_0_25px_rgba(163,230,53,0.5)] font-bold',
    secondary: 'bg-white text-atomic-black hover:bg-gray-100 border border-transparent',
    outline: 'bg-transparent text-white border-2 border-white/20 hover:border-atomic-green hover:bg-atomic-green/10 hover:text-atomic-green',
    ghost: 'bg-transparent text-gray-300 hover:text-atomic-green hover:bg-atomic-green/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg font-semibold'
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn('inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atomic-green disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], fullWidth && 'w-full', className)} {...props} data-id="element-192">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';